module.exports = __webpack_public_path__ + "static/media/SPA501G_large.9af1082e.png";